import { CiCircleCheck } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import { getApiInstance } from "../../../utils/api";

// Piezas compartidas por la pestaña "Visitas" de la ficha del gestor y la
// pagina de Informes de visitas: catalogo de valoraciones, secciones del
// informe y el formateo de la fecha.

// Valoracion global de un informe de visita (indice = codValoracion en BD)
export const VALORACIONES_VISITA = [
    { value: "1", label: "Favorable" },
    { value: "2", label: "Favorable con observaciones" },
    { value: "3", label: "Desfavorable" },
];

export const BADGE_VALORACION_VISITA = {
    1: { type: "success", label: "Favorable", Icon: CiCircleCheck },
    2: { type: "warning", label: "Favorable con observaciones", Icon: CgDanger },
    3: { type: "danger", label: "Desfavorable", Icon: CgDanger },
};

// Secciones de texto largo del informe, en el orden en el que se leen
export const SECCIONES_INFORME_VISITA = [
    { key: "introduccion", label: "Introducción" },
    { key: "objetivos", label: "Objetivos de la visita" },
    { key: "descripcionInstalacion", label: "Descripción de la instalación" },
    { key: "desarrollo", label: "Desarrollo de la visita" },
    { key: "observaciones", label: "Observaciones y hallazgos" },
    { key: "conclusiones", label: "Conclusiones" },
    { key: "recomendaciones", label: "Recomendaciones" },
];

// La fecha llega como "2025-12-12T00:00:00"; se corta en seco para no
// arrastrar desfases de zona horaria ni en la tabla ni en el input date.
export const soloFecha = (valor) => (valor ? String(valor).slice(0, 10) : "");

export const formatFechaVisita = (valor) => {
    const fecha = soloFecha(valor);
    return fecha ? fecha.split("-").reverse().join("/") : "";
};

// El API devuelve el ISO completo; el input date y los filtros de fecha
// necesitan "YYYY-MM-DD".
export const mapVisitas = (lista) =>
    (Array.isArray(lista) ? lista : []).map((visita) => ({
        ...visita,
        fechaVisita: soloFecha(visita.fechaVisita),
    }));

// El header trae filename= y filename*=UTF-8''...; se prioriza este ultimo
// porque es el que conserva las tildes del nombre.
const nombreFicheroDescarga = (contentDisposition, porDefecto) => {
    if (!contentDisposition) return porDefecto;

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        return decodeURIComponent(utf8Match[1]);
    }

    const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    return fileNameMatch && fileNameMatch[1] ? fileNameMatch[1] : porDefecto;
};

// Descarga el Word (.docx) de un informe de visita concreto. Lanza si falla:
// cada pantalla decide como avisar al usuario.
export const descargarInformeVisitaWord = async (visita) => {
    const codVisita = visita?.codVisita;

    if (!codVisita) return;

    const api = getApiInstance();
    const response = await api.get(
        `/api/ProveedoresVisitas/CreateReportVisitaWord/${codVisita}`,
        { responseType: "blob" }
    );

    const fileName = nombreFicheroDescarga(
        response.headers["content-disposition"],
        `Informe_Visita_${codVisita}.docx`
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
